import React from "react";
import styles from "./page.module.css";
import { ReactComponent as Logo } from "../../../../images/logo.svg";
import { ContinueButton } from "../../../../components/continue-button/continue-button";
import { Step } from "../step/step";

const Page = (props) => {
  const buttonStyles = {
    backgroundColor: "#C987EC",
    fontSize: '22px'
  };
  return (
    <div className={styles.page}>
      <div>
        <div className={styles.logo}>
          <Logo />
        </div>
        {!props.hideSteps && <Step currentStep={props.currentStep} />}
        <h1 className={styles.title}>{props.title}</h1>
      </div>
      {props.children}
      {!props.hideContinueButton && (
        <ContinueButton
          text={props.btnText}
          link={props.nextPageLink}
          onClick={props.onContinue}
          enabled={props.canGoToNextPage}
          buttonStyles={buttonStyles}
        />
      )}
    </div>
  );
};

export { Page };
